import React from 'react';
import useDynamicGreeting from '../../hooks/ui/useDynamicGreeting';

const EmptyState = ({ chatId }) => {
  const { greeting } = useDynamicGreeting(chatId);

  return (
    <div className="h-full flex flex-col items-center justify-center">
      <h1 className="text-3xl font-semibold text-black dark:text-white">
        {greeting}
      </h1>
    </div>
  );
};

export default EmptyState;
